import React from "react";
import { Link } from "react-router-dom";

// This page is always Spanish, per requirements.
export default function ThankYou() {
  return (
    <main
      className="min-h-[calc(100vh-5rem)] bg-[#F8F9FA] flex items-center"
      data-testid="thank-you-page"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#B48E5D] mb-6">
          Metrosenda
        </p>
        <h1 className="font-heading text-4xl md:text-6xl leading-tight text-[#0F172A]">
          ¡Gracias por sumarte!
        </h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">
          Recibimos tu suscripción correctamente. Vas a recibir las próximas
          novedades sobre proyectos residenciales y actualizaciones de la
          plataforma en tu correo electrónico.
        </p>
        <p className="mt-3 text-sm text-slate-500 leading-relaxed">
          Revisá tu bandeja de entrada (y la carpeta de spam) para confirmar
          que nuestros mensajes lleguen sin inconvenientes.
        </p>
        <div className="mt-10">
          <Link
            to="/"
            className="inline-block px-8 py-4 bg-[#1E3A8A] text-white font-semibold text-sm uppercase tracking-[0.18em] hover:bg-[#152b6a]"
            data-testid="thank-you-back-home"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
